import { Toast } from 'vant'

/**
 * 调用系统分享，不支持时自动复制链接到剪贴板
 */
export async function shareContent({ title, text, url }) {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url })
      return { shared: true }
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('[Share] navigator.share failed:', err)
      }
      return { shared: false }
    }
  }

  return copyToClipboard(url)
}

/**
 * 复制文本到剪贴板
 */
export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text)
      return { copied: true }
    }
  } catch (err) {
    console.error('[Share] clipboard write failed:', err)
  }

  // Fallback: 用 input 选中复制
  const input = document.createElement('input')
  input.value = text
  input.style.position = 'fixed'
  input.style.opacity = '0'
  document.body.appendChild(input)
  input.select()
  try {
    document.execCommand('copy')
    return { copied: true }
  } catch (err) {
    console.error('[Share] execCommand copy failed:', err)
    return { copied: false }
  } finally {
    document.body.removeChild(input)
  }
}

/**
 * 构造群邀请分享链接
 */
export function buildChannelShareUrl(channelCode) {
  const origin = window.location.origin
  return `${origin}/share/channel/${encodeURIComponent(channelCode)}.html?ref=share`
}

/**
 * 构造帖子分享链接
 */
export function buildSessionShareUrl(channelId, chatSessionId) {
  const origin = window.location.origin
  return `${origin}/share/session/${encodeURIComponent(chatSessionId)}.html?channelId=${encodeURIComponent(channelId)}&ref=share`
}

/**
 * 构造匹配详情分享链接
 */
export function buildMatchShareUrl(matchDetailId, userId) {
  const origin = window.location.origin
  let url = `${origin}/share/match/${encodeURIComponent(matchDetailId)}.html?ref=share`
  if (userId) {
    url += `&userId=${encodeURIComponent(userId)}`
  }
  return url
}

/**
 * 分享群
 * @param {Object} channel - { channelId, channelCode, name, description }
 * @param {Object} i18n - Vue i18n 实例，提供 $t 方法
 */
export async function shareChannel(channel, i18n) {
  if (!channel || !channel.channelCode) {
    Toast(i18n.t('toast_no_share_data'))
    return { shared: false }
  }

  const url = buildChannelShareUrl(channel.channelCode)
  const title = channel.name || i18n.t('app_name')
  const text = channel.description || i18n.t('channel_invite_defaultDesc', { name: title })

  const result = await shareContent({ title, text, url })
  if (result.copied) {
    Toast.success(i18n.t('toast_link_copied'))
  }
  return result
}

/**
 * 分享帖子
 * @param {Object} session - { chatSessionId, channelId, fromUserName, aiSummary, userMsg }
 * @param {Object} i18n - Vue i18n 实例
 */
export async function shareSession(session, i18n) {
  if (!session || !session.chatSessionId || !session.channelId) {
    Toast(i18n.t('toast_no_share_data'))
    return { shared: false }
  }

  const url = buildSessionShareUrl(session.channelId, session.chatSessionId)
  const userName = session.fromUserName || i18n.t('anonymous')
  const summary = session.aiSummary || formatUserMsgPreview(session.userMsg) || ''
  const text = summary
    ? i18n.t('share_session_text', { userName: userName, summary: summary })
    : i18n.t('share_session_text_no_summary', { userName: userName })

  const result = await shareContent({ title: i18n.t('share_session_title'), text, url })
  if (result.copied) {
    Toast.success(i18n.t('toast_link_copied'))
  }
  return result
}

/**
 * 分享匹配详情
 * @param {Object} matchDetail - { matchDetailId, matchLevel, briefMatchReason }
 * @param {Object} i18n - Vue i18n 实例
 */
export async function shareMatch(matchDetail, i18n) {
  if (!matchDetail || !matchDetail.matchDetailId) {
    Toast(i18n.t('toast_no_share_data'))
    return { shared: false }
  }

  const url = buildMatchShareUrl(matchDetail.matchDetailId, matchDetail.userId)
  const matchLevelLabel = matchDetail.matchLevel === 'interested'
    ? i18n.t('label_worth_a_look')
    : i18n.t('label_perfect_match')
  const text = matchDetail.briefMatchReason
    ? `${matchLevelLabel}: ${matchDetail.briefMatchReason}`
    : matchLevelLabel

  const result = await shareContent({ title: i18n.t('share_match_title'), text, url })
  if (result.copied) {
    Toast.success(i18n.t('toast_link_copied'))
  }
  return result
}

function formatUserMsgPreview(userMsg) {
  if (!userMsg) return ''
  try {
    const parsed = JSON.parse(userMsg)
    if (Array.isArray(parsed)) {
      const texts = parsed
        .filter(item => item.type === 'plaintext')
        .map(item => item.content)
        .join(' ')
      return texts || ''
    }
  } catch (e) {
    // 非 JSON，直接返回
  }
  return userMsg
}



// WEBPACK FOOTER //
// ./src/services/share.js